module.exports = __webpack_public_path__ + "static/PANO_20131220_215649-c4fed5f14c4519a5e16c3212f4359178.jpg";